import { useState, useEffect } from "react";
import { useGerenciamento } from "../Context/GerenciamentoContext";
import { Link, useNavigate } from 'react-router-dom';
import "../../App.css";
import "./Forms.css";

import avisoIcon from "../../assets/icons/perfil.png";
import AvisosService from "../../services/AvisosService";

export default function AvisosForm({
  itemSelecionado,
  modo,
  onSubmit,
  onClose,
}) {
  const [form, setForm] = useState({
    idAviso: null,
    tipo: "T",
    referencia: "",
    descricao: "",
    ativo: true,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { setRetorno } = useGerenciamento();
  const [submitState, setSubmitState] = useState("IDLE");   

  // ==========================
  // LOAD MODO
  // ==========================
  useEffect(() => {
    if (modo === "novo") {
      setForm({
        idAviso: null,
        tipo: "T",
        referencia: "",
        descricao: "",
        ativo: true,
      });
    }

    if (modo === "alterar" && itemSelecionado) {
      setForm({
        idAviso: itemSelecionado.IDAVISO,
        tipo: itemSelecionado.TIPO || "T",
        referencia: itemSelecionado.REFERENCIA || "",
        descricao: itemSelecionado.DESCRICAO || "",
        ativo: !!itemSelecionado.ATIVO,
      });
    }
  }, [modo, itemSelecionado]);

  // ==========================
  // HANDLERS
  // ==========================
  function handleChange(e) {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  }

  // ==========================
  // VALIDATION
  // ==========================
  function validarCampos() {
    const e = {};

    if (!form.tipo) e.tipo = "Informe o tipo";
    if (!form.referencia) e.referencia = "Informe a referência";
    if (!form.descricao) e.descricao = "Informe a descrição";

    return e;
  }

  // ==========================
  // SUBMIT
  // ==========================
  async function handleSubmit(e) {
    e.preventDefault();

    const validation = validarCampos();
    setErrors(validation);
    if (Object.keys(validation).length) return;

    setLoading(true);

    try {
      if (modo === "novo") {
        const payload_create = {
          tipo: form.tipo, 
          referencia: form.referencia,
          descricao: form.descricao,
          ativo: form.ativo
        };

        await AvisosService.create(payload_create);

        setRetorno({
          tipo: "sucesso",
          mensagem: "Aviso criado com sucesso!",
        });
        setSubmitState("SUCCESS");        
      }

      if (modo === "alterar") {
        const payload_update =  {
          tipo: form.tipo,
          referencia: form.referencia,
          descricao: form.descricao,
          ativo: form.ativo
        };

        await AvisosService.update(form.idAviso, payload_update)

        setRetorno({
          tipo: "sucesso",
          mensagem: "Aviso atualizado com sucesso!",
        });
        setSubmitState("SUCCESS");    
      }

      onClose();
    } catch (error) {
        setRetorno({
          tipo: "erro",
          mensagem:
            modo === "novo"
              ? "Erro ao criar Aviso."
              : "Erro ao atualizar Aviso.",
        });

        setSubmitState("ERROR");
    } finally {
      setLoading(false);
    }
  }

  // ==========================
  // RENDER
  // ==========================
  return (
    <div className="Form-Interno-Container">
      <form onSubmit={handleSubmit}>
        <div className="Form-Interno-title">
          <img src={avisoIcon} alt="avisos" className="icon" />
          {modo === "novo" ? "Cadastro de aviso" : "Alterar aviso"}
        </div>

        <div className="Form-Interno-linha"></div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Tipo: *</div>
          <select name="tipo" value={form.tipo} onChange={handleChange}>
            <option value="T">Trabalho</option>
            <option value="I">Informações</option>
          </select>
          {errors.tipo && <span style={{ color: "red" }}>{errors.tipo}</span>}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Referência: *</div>
          <input
            name="referencia"
            value={form.referencia}
            onChange={handleChange}
          />
          {errors.referencia && (
            <span style={{ color: "red" }}>{errors.referencia}</span>
          )}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Descrição: *</div>
          <input
            name="descricao"
            value={form.descricao}
            onChange={handleChange}
          />
          {errors.descricao && (
            <span style={{ color: "red" }}>{errors.descricao}</span>
          )}
        </div>

          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Status:</div>
            <select name="ativo" value={String(form.ativo)} onChange={handleChange}>
            <option selected value="">Selecione</option>
              <option value={true}>Ativo</option>
              <option value={false}>Inativo</option>
            </select>
          </div>

        <div className="Form-Interno-alinhamento-button">
          <button type="submit" disabled={loading} className="Form-Interno-button">
            {loading ? "Enviando..." : "Salvar"}
          </button>

          <button type="button" className="Form-Interno-button" onClick={onClose}>
            Voltar
          </button>
        </div>
      </form>
    </div>
  );
}
